import { useMutation as e } from "@maat/store-hooks";
import { referralApi as t } from "@maat/api-main";
//#region src/partners/useReferralFingerprintMutation.ts
var n = () => e({ mutationFn: (e) => t.sendFingerprint(e) });
//#endregion
export { n as useReferralFingerprintMutation };
